import React from 'react';
import PropTypes from 'prop-types';
import SignaturePreviewButtons from './components/SignaturePreviewButtons';

const emptyBtnStyle = {
  height: '100%',
  border: 'none',
  background: 'transparent',
};

export default class SignaturePreview extends React.Component {
  constructor(props) {
    super(props);
    this.renderTitle = this.renderTitle.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  renderTitle() {
    return this.props.title ? (<div className="title">{this.props.title}</div>) : null;
  }

  renderContent() {
    if (this.props.imageUrl) {
      return (
        <div className="img-wrap-container">
          <button
            className="img-wrap"
            onClick={(e) => { this.props.submitPopup(this.props.type, e); }}
          >
            <img src={this.props.imageUrl} alt="" />
          </button>
          <SignaturePreviewButtons
            deleteSignatureOnClick={this.props.submitClear}
            hasUseButton={this.props.forSigning}
            type={this.props.type}
            useSignatureOnClick={this.props.submitPopup}
          />
        </div>
      );
    }

    switch (this.props.type) {
      case 'type':
        return (
          <button
            className="empty"
            style={emptyBtnStyle}
            onClick={() => { this.props.submitCreator('type'); }}
          >
            {this.props.buttonText}
            {this.props.buttonChildren}
          </button>
        );
      case 'draw':
        return (
          <button
            className="empty"
            style={emptyBtnStyle}
            onClick={() => { this.props.submitCreator('draw'); }}
          >
            {this.props.buttonText}
            {this.props.buttonChildren}
          </button>
        );
      case 'upload':
        return (
          <button
            className="empty"
            style={emptyBtnStyle}
            onClick={() => { this.props.submitCreator('upload'); }}
          >
            {this.props.buttonText}
            {this.props.buttonChildren}
          </button>
        );
      default:
        return '';
    }
  }

  render() {
    const boxClass = `${this.props.type}-box box`;
    const contentClass = this.props.imageUrl ? 'content my-docs-redesign' : 'content my-docs-redesign content-empty';

    return !this.props.visible ? null : (
      <div className={boxClass}>
        {this.renderTitle()}
        <div
          className={contentClass}
        >
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

SignaturePreview.propTypes = {
  buttonChildren: PropTypes.node,
  buttonText: PropTypes.string,
  forSigning: PropTypes.bool,
  imageUrl: PropTypes.string,
  submitClear: PropTypes.func.isRequired,
  submitCreator: PropTypes.func.isRequired,
  submitPopup: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

SignaturePreview.defaultProps = {
  buttonChildren: null,
  buttonText: 'Add Your Signature',
  forSigning: false,
  imageUrl: null,
  submitPopup: null,
  title: null,
};



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignaturePreview.jsx